var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_2355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0534 3.69778L12.4445 1.07556C12.2721 0.904029 12.0388 0.807739 11.7956 0.807739C11.5524 0.807739 11.3191 0.904029 11.1467 1.07556L1.8978 10.3111L1.05336 13.9556C1.02423 14.0888 1.02523 14.2268 1.05628 14.3596C1.08734 14.4924 1.14766 14.6166 1.23285 14.7231C1.31804 14.8296 1.42595 14.9157 1.54868 14.9751C1.67141 15.0346 1.80588 15.0658 1.94225 15.0667C2.00579 15.0731 2.06982 15.0731 2.13336 15.0667L5.8178 14.2222L15.0534 4.99556C15.2249 4.82316 15.3212 4.58986 15.3212 4.34667C15.3212 4.10347 15.2249 3.87018 15.0534 3.69778V3.69778ZM5.37336 13.4222L1.92003 14.1467L2.70669 10.76L9.62669 3.86667L12.2934 6.53333L5.37336 13.4222ZM12.8889 5.88889L10.2222 3.22222L11.7689 1.68444L14.3911 4.35111L12.8889 5.88889Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_2355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/PencilIcon.5b9cc07dfe640af596504565de5b92ad.svg";
export { ForwardRef as ReactComponent };